"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToCamelCase = function (str) { return str.replace(/([-_][a-z])/g, function (group) { return group.toUpperCase()
    .replace('-', '')
    .replace('_', ''); }); };
//# sourceMappingURL=utils.js.map